// Analytics entry, imported by both pages.
//
// It is its own module because /officialrules has no other JavaScript: that page
// is an exported Google Doc with no component on it, so it loads this file
// directly. The landing page picks it up through main.ts.
import { initAnalytics } from "./lib/analytics";
import { startPageTracking } from "./lib/analytics-events";

initAnalytics();

// The page-level custom events — scroll depth, link clicks, form start. Started
// here rather than inside initAnalytics so the two stay separable, and so the
// rules page gets them as well: it has no component, and its depth and its links
// are the only interactions it has.
startPageTracking();
